<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtolistkomisix">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Ubah Jenis Komisi</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page flex-100">

            <div class="flex-1">

                <div class="p-x-20 p-t-16 p-d-20 w-limit">
                    <div class="form-group mod">
                        <label for="nama-komisi" class="form-label require">Nama Komisi</label>
                        <input type="text" class="form-control" id="nama-komisi" placeholder="Nama komisi..." v-on:keyup="inputnamakomix" v-model="editnama_komisikomisix">
	                    <ErrorMessage class="error" label="Nama Komisi" :validation="$v.editnama_komisikomisix"></ErrorMessage>
                    </div>
                    <label for="radio1" class="form-label m-t-16">Dihitung dari Nota</label>
                    <div class="radio-group">
                        <div class="radio-wrapper">
                            <div class="radio-item">
                                <input type="radio" id="allnotaedit" name="allnotaedit" @click="cekValue1" value="0" v-model="editjenis_notakomisix">
                                <label for="allnotaedit">Semua Nota</label>
                            </div>
                            <div class="radio-item">
                                <input type="radio" id="nota2edit" name="nota2edit" @click="cekValue" value="1" v-model="editjenis_notakomisix">
                                <label for="nota2edit">Nota Lunas Saja</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="separator"></div>

                <div class="p-x-20 p-t-16 w-limit">
                    <div class="f-16">Total penjualan akan dihitung dari total nota yang dibayar konsumen dikurangi
                        pajak.

                        <div class="item-create-komisi-wrapper">

                            <div class="item-create-komisi d-flex m-t-16"  v-for="(item, eachData) in editkomisix" v-bind:id="'form' + eachData">
                                <div class="flex-1 m-r-8">
                                    <label for="form1" class="form-label">Penjualan Mencapai</label>
                                    <div class="input-group mod">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Rp</span>
                                        </div>
                                        <input type="text" class="form-control nominalKey" :data="eachData" v-bind:id="'omset'+eachData" @keyup="inputnumberpokok(eachData)"
                                               placeholder="2.000.000" v-bind:value="item.nominal">
                                    </div>
                                </div>
                                <div class="">
                                    <label for="form2" class="form-label">Komisi</label>
                                    <div class="d-flex-align-center">
                                        <div class="input-group mod input-komisi m-r-8">
                                            <input type="text" class="form-control" v-bind:id="'komisi'+eachData" @keyup="max100(eachData)"
                                                   v-bind:value="item.persentase" placeholder="1">
                                            <div class="input-group-append">
                                                <span class="input-group-text">%</span>
                                            </div>
                                        </div>
                                        <div class="icon-32 icon-trash-circle active hapusEnable" @click="removeFormkomisx(eachData)"></div>
                                        <div class="icon-32 icon-trash-circle hapusDisable"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="click-to-add m-t-16 d-flex" @click="addFormkomisix">
                            <div class="icon-24 icon-plus-blue"></div>
                            <div class="m-l-4 f-16 f-semi f-c-blue">Tambah target penjualan</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="button-wrapper p-x-20 p-t-24 p-d-20 w-limit w-100" @click="createcommision" id="BtnEditkomisx">
                <div class="btn smart-primary"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                                     v-if="editisClicked === true"></span><span id="textBtnEditkomisx">Simpan Perubahan</span></div>
            </div>
        </div>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "EditKomisix",
        props:['dataidkomisix'],
	    components: { ErrorMessage },
        data(){
            return{
                editisClicked:false,
                editkomisix:[],
                editcloneCountkomisix: 1,
                editdatakomisix: 1,
                editdataCountCheckkomisix: 1,
                editarrayKomisiSaleskomisix: [],
                editjenis_notakomisix:'0',
                editnama_komisikomisix:'',
                editarrayKomisixSales:[],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    editnama_komisikomisix: {
		    	required,
			    minLength: minLength(2),
		    }
	    },
        mounted() {
            $('.hapusEnable').hide();
            $("#allnotaedit").prop("checked", true);
            this.detailkomisix()
	        // this.backButtonPressed(this.backtolistkomisix)
        },
        methods:{
            backtolistkomisix(){
                this.$emit('backtolist');
            },

            cekValue() {
                var value = $("input[name=notalunas]:checked").val()
                $("#allnotaedit").prop("checked", false);
                this.editjenis_notakomisix = value

            },
            cekValue1() {
                var value = $("input[name=allnotaedit]:checked").val()
                $("#nota2edit").prop("checked", false);
                this.editjenis_notakomisix = value

            },
            addFormkomisix() {
                this.editkomisix.push({
                    nominal : "",
                    persentase : ""
                })
                var cloneAdd = this.editcloneCountkomisix + 1;
                var cloneAdded = this.editdataCountCheckkomisix + 1;
                this.editcloneCountkomisix = cloneAdd;
                this.editdataCountCheckkomisix = cloneAdded;
                this.editdatakomisix = cloneAdded;
                setTimeout(() => {
                    if (this.editcloneCountkomisix > 1) {
                        $(".hapusDisable").attr("style", "display:none !important");
                        $(".hapusEnable").attr("style", "display:block !important");
                    } else {
                        $(".hapusDisable").attr("style", "display:block !important");
                        $(".hapusEnable").attr("style", "display:none !important");
                    }
                }, 50)
            },

            removeFormkomisx(key) {
                $("#form" + key).remove()
                var cloneMin = this.editdataCountCheckkomisix - 1;
                this.editdataCountCheckkomisix = cloneMin;
                this.editdatakomisix = cloneMin;
                setTimeout(() => {
                    if (this.editdataCountCheckkomisix > 1) {
                        $(".hapusDisable").attr("style", "display:none !important");
                        $(".hapusEnable").attr("style", "display:block !important");
                    } else {
                        $(".hapusDisable").attr("style", "display:block !important");
                        $(".hapusEnable").attr("style", "display:none !important");
                    }
                }, 50)
            },

            inputnamakomix(event){
                var nums = event.target.value;
                var namakomisix = nums.replace(/[^0-9A-Za-z_%&.,' -]+/,'');
                this.editnama_komisikomisix = namakomisix;
                this.cekValidate()
            },

            cekValidate(){
            	return
                var namakomisi = this.editnama_komisikomisix;
                var lenght = namakomisi.length;
                if (lenght >= 2) {
                    $('#BtnEditkomisx').prop('disabled', false);
                } else {
                    $('#BtnEditkomisx').prop('disabled', true);
                }
            },

            inputnumberpokok(key){
                var handleevent = $('#omset'+ key).val();
                var handlenumber = handleevent.replace(/[^0-9]+/,'');
                $('#omset'+ key).val(handlenumber)
                this.formatrupiah(key)
            },

            formatrupiah(key){
                var rupiah = $('#omset'+key).val();;
                var formattedrupiah = this.newrupiah(rupiah);
                $('#omset'+key).val(formattedrupiah)
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },
	
	        max100(key){
		        var inputkomisi = $('#komisi' +key).val()
		        // $('.upah').keyup(function(){
		        if (inputkomisi> 100){
			        $('#komisi' +key).val('100');
		        }
		        // });
		        this.upahinput(key)
		        this.decimal(key)
	        },
	
	        upahinput(key){
		        var handleeventkomisi = $('#komisi'+ key).val().substring(0,4);
		        var handlenumber = handleeventkomisi.replace(/[^0-9,]+/,'');
		        $('#komisi'+ key).val(handlenumber)
		        // var nums = event.target.value;
		        // var number = nums.replace(/[^0-9]+/, '');
		        // event.target.value = number;
	        },
	
	        decimal(key){
		        $('#komisi' + key).keydown(function (e) {
			        //Get the occurence of decimal operator
			        var match = $(this).val();
			        if(match!=null){
				        // Allow: backspace, delete, tab, escape and enter
				        if ($.inArray(e.keyCode, [46,8, 9, 27, 13, 110]) !== -1 ||
					        // Allow: Ctrl+A
					        (e.keyCode == 65 && e.ctrlKey === true) ||
					        // Allow: home, end, left, right
					        (e.keyCode >= 35 && e.keyCode <= 39)) {
					        // let it happen, don't do anything
					        return;
				        }  // Ensure that it is a number and stop the keypress
				        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105 )&&(e.keyCode==190)) {
					        e.preventDefault();
				        }
			        }
			        else{
				        // Allow: backspace, delete, tab, escape, enter and .
				        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
					        // Allow: Ctrl+A
					        (e.keyCode == 65 && e.ctrlKey === true) ||
					        // Allow: home, end, left, right
					        (e.keyCode >= 35 && e.keyCode <= 39)) {
					        // let it happen, don't do anything
					        return;
				        }
				        // Ensure that it is a number and stop the keypress
				        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
					        e.preventDefault();
				        }
			        }
		        });
		
		        $('#komisi' + key).keyup(function () {
			        if ($(this).val().indexOf('.') != -1) {
				        if ($(this).val().split(".")[1].length >= 2) {
					        if (isNaN(parseFloat(this.value))) return;
					        this.value=parseFloat(this.value).toFixed(2);
				        }
			        }
		        })
	        },

            next() {
                var arrayKomisiStatic = []
                $(".nominalKey").each(function (index) {
                    var idData = $(this).attr("data");
                    var nominalKomisi = $("#omset" + idData).val();
                    var percentageKomisi = $("#komisi" + idData).val();
                    var fixed2 = parseFloat(percentageKomisi.replace(",", "."))
                    var fix = fixed2.toFixed(2)
                    arrayKomisiStatic.push({
                        total_omset: nominalKomisi,
                        persentase_komisi: fix,
                    });
                });
                this.editarrayKomisixSales = arrayKomisiStatic
            },

	        errorValidation() {
		        this.$v.editnama_komisikomisix.$touch()
            	return this.$v.editnama_komisikomisix.$invalid
	        },
            async createcommision(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                this.editisClicked = true;
                $('#BtnEditkomisx').prop('disabled', true);
                $('#textBtnEditkomisx').hide();
                this.next()
                try {
                    // var idowner = localStorage.getItem('idowner')
                    var detail = this.editarrayKomisixSales;
                    var createkomisi={
                        "nama": this.editnama_komisikomisix,
                        "dihitung_dari_nota": this.editjenis_notakomisix.toString(),
                        "detail_jenis_komisi_sales": detail
                    };
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_jenis_komisi_sales?idjeniskomisi=' + this.dataidkomisix.idkomisix, JSON.stringify(createkomisi), this.requestHeaders);
                    if (response.data.status === true) {
                        this.editnama_komisikomisix=''
                        this.editjenis_notakomisix=0
                        this.editcloneCountkomisix =1
                        $('.upah').val('')
	                    this.$toast.success(response.data.msg)
                        this.editisClicked = false;
                        $('#BtnEditkomisx').prop('disabled', false);
                        $('#textBtnEditkomisx').show();
                        this.backtolistkomisix()
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.editisClicked = false;
                        $('#BtnEditkomisx').prop('disabled', false);
                        $('#textBtnEditkomisx').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.editisClicked = false;
	                $('#BtnEditkomisx').prop('disabled', false);
	                $('#textBtnEditkomisx').show();
                }
            },

            async detailkomisix(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_komisi_sales?idkomisi=' + this.dataidkomisix.idkomisix, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        var detailkomisix = response.data.data;
                        this.editnama_komisikomisix = detailkomisix.nama;
                        this.editjenis_notakomisix = detailkomisix.dihitung_dari_nota;
                        if (detailkomisix.dihitung_dari_nota === 1) {
                            $("#allnotaedit").prop("checked", true)

                        } else if (detailkomisix.dihitung_dari_nota === 2) {
                            $("#nota2edit").prop("checked", true)
                        }
                        var clone = detailkomisix.detail_jenisgaji_sales;
                        for (var i = 0; i < clone.length; i++) {
                            var komisiclone = clone[i].total_omset;
                            var komisiclonepersen = clone[i].persentase_komisi;
                            var toRp = this.newrupiah(komisiclone.toString());
                            this.editkomisix.push({
                                nominal : toRp,
                                persentase : komisiclonepersen.toFixed(2).toString().replace(".", ",")
                            })
                        }
                        this.editcloneCountkomisix = clone.length
                        setTimeout(() => {
                            if (this.editcloneCountkomisix > 1) {
                                $(".hapusDisable").attr("style", "display:none !important");
                                $(".hapusEnable").attr("style", "display:block !important");
                            } else {
                                $(".hapusDisable").attr("style", "display:block !important");
                                $(".hapusEnable").attr("style", "display:none !important");
                            }
                        }, 50)
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false
	                $('#textBtn2').show()
	                $('#btnNext').prop('disabled', false);
                }
            },
        }
    }
</script>

<style scoped>

</style>